import { HugeiconsIcon } from '@hugeicons/react';
import { UserAiIcon } from '@hugeicons/core-free-icons';
import { useAssistant } from '@services/AssistantProvider';
import { MessageList } from './MessageList';
import { MessageInput } from './MessageInput';
import { TypingIndicator } from './TypingIndicator';
import styles from './AssistantSidebar.module.scss';

export const AssistantSidebarExpanded = ({ onCollapse }) => {
	const { messages, isLoading } = useAssistant();

	return (
		<div className={styles.expandedContainer}>
			{/* Header */}
			<div className={styles.sidebarHeader}>
				<HugeiconsIcon icon={UserAiIcon} className={styles.headerIcon} size={24} />
				<div className={styles.headerContent}>
					<h2 className={styles.headerTitle}>Store Assistant</h2>
				</div>
				<button className={styles.collapseButton} onClick={onCollapse} aria-label="Collapse assistant" title="Collapse assistant">
					<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M12 5L7 10L12 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
					</svg>
				</button>
			</div>

			{/* Body */}
			<div className={styles.sidebarBody}>
				{messages.length > 0 && <MessageList messages={messages} />}
				{isLoading && <TypingIndicator />}
			</div>

			{/* Footer */}
			<div className={styles.sidebarFooter}>
				<MessageInput />
			</div>
		</div>
	);
};
